export const SUPPORTED_LANGUAGES = ['en', 'es', 'de', 'it', 'fr'];
